import {
  CLEAR_STATE,
  BANK_INTEGRATION,
  DOCUMENT_UPLOAD,
  TURNOVER,
  PERSONAL_NUMBER,
  LOAN_PURPOSE_ADDITIONAL,
  LOAN_PURPOSE,
  CLEAR_DOCUMENT_UPLOAD,
} from '~/actions/actionTypes';
import { IOnboarding } from '~/sharedInterfaces/SharedInterfaces';

const INITIAL_STATE: IOnboarding = {};

const onboardingReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case TURNOVER:
    case DOCUMENT_UPLOAD:
    case BANK_INTEGRATION:
    case PERSONAL_NUMBER:
      return {
        ...state,
        [action.type]: action.payload,
      };
    case LOAN_PURPOSE_ADDITIONAL:
      return {
        ...state,
        loanPurpose: {
          ...state.loanPurpose,
          additionalInfo: action.payload,
        },
      };
    case LOAN_PURPOSE:
      return {
        ...state,
        loanPurpose: {
          ...state.loanPurpose,
          purpose: action.payload,
        },
      };
    case CLEAR_STATE:
      return {
        ...action.payload,
      };
    case CLEAR_DOCUMENT_UPLOAD:
      return {
        ...state,
        documentUpload: '',
      };
    default:
      return state;
  }
};

export default onboardingReducer;
